import { cn } from "@tellescope/ui";
import { ReactNode } from "react";
import { PageHeader } from "./PageHeader";
import { AppNavbar } from "./AppNavbar";

interface MainLayoutProps {
  children: ReactNode;
  useDefaultTitle?: boolean;
}

export const MainLayout = ({ children, useDefaultTitle = true }: MainLayoutProps) => {
  return (
    <div className="min-h-screen relative">
      <div className="flex h-full z-40 transition-all duration-300 w-full" data-trackingid="main-layout-wrapper">
        <AppNavbar />
        <main
          className={cn("transition-all duration-300 min-h-screen flex-1 min-w-0")}
          data-trackingid="main-layout-content"
        >
          <div className="flex-1 flex flex-col h-svh relative">
            {!useDefaultTitle ? (
              children
            ) : (
              <>
                <PageHeader />
                {/* Main Content Area */}
                <div className="flex-1 overflow-auto">
                  <div className="p-6 space-y-6 h-full">{children}</div>
                </div>
              </>
            )}
          </div>
        </main>
      </div>
    </div>
  );
};
